import { render, staticRenderFns } from "./NoticeDialog.vue?vue&type=template&id=63284845&scoped=true"
import script from "./NoticeDialog.vue?vue&type=script&lang=js"
export * from "./NoticeDialog.vue?vue&type=script&lang=js"
import style0 from "./NoticeDialog.vue?vue&type=style&index=0&id=63284845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63284845",
  null
  
)

export default component.exports